import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../../services/data.service';
import {User} from '../../services/user/user';

@Injectable({
  providedIn: 'root'
})
export class AgencyUserService extends DataService {

  public observable$: any;

  constructor(http: HttpClient) {
    super(http);
    //   this.setHost("http://localhost:4600");
    this.setUri(this.baseURI);
  }

  private baseURI = this.apiUri + '/agencyUser/';

  // Function to get the Users list by a organizationId
  getUsersListByOrgId(organizationId: number): Observable<any> {
    const usersListUrl = this.apiUri + '/organization/' + organizationId + '/organizationId';
    this.setUri(usersListUrl);
    return this.get();
  }

  // Function to get the Agency User roles from DB
  getAgencyUserRoles(): Observable<any> {
    const agencyUsersRolestUrl = this.baseURI + 'agencyUserRoles';
    this.setUri(agencyUsersRolestUrl);
    return this.get();
  }

  // Function to get the Carrier User roles from DB
  getCarrierUserRoles(): Observable<any> {
    const carrierUsersRolestUrl = this.baseURI + 'carrierUserRoles';
    this.setUri(carrierUsersRolestUrl);
    return this.get();
  }

  // Function to create a new agency or carrier user
  createUser(user: User, organizationId: number): Observable<any> {
    return this.http.post(this.baseURI + 'createUser/' + organizationId + '/organizationId', user);

  }

  // Function to update a existing agency or carrier user
  updateUser(user: User, organizationId: number): Observable<any> {
    return this.http
      .put(this.baseURI + 'updateUser/' + organizationId + '/organizationId', user);
  }

  // Function to reset password of agency or carrier user
  resetPassword(user: User, organizationId: number): Observable<any> {
    return this.http
      .get(this.baseURI + 'resetPassword/' + user.email + '/email');
  }

  // Function to delete a existing agency or carrier user
  /*
  deleteUser(userId: number): Observable<any> {
      console.log("In deleteUser, userId is : " + userId);
      this.setUri(this.baseURI + 'userId/');
      return this.deleteWithPut(userId);
  }
  */

  // Function to delete a existing agency or carrier user
  deleteUser(user: User, organizationId: number): Observable<any> {
    return this.http
      .put(this.baseURI + 'deleteUser/' + organizationId + '/organizationId', user);

  }

}
